import { defineMessages } from 'react-intl';
export default defineMessages({
  stage: {
    defaultMessage: 'Stage',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MoveToStage.stage`,
  },
  aiNoFinalStageMessage: {
    defaultMessage:
      'AI regulations prevent automated hiring decisions based on AI assessment results.',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MoveToStage.aiNoFinalStageMessage`,
  },
  aiTerminalStageValidationError: {
    defaultMessage:
      'AI regulations prevent automated hiring decisions. Please change the stage to a non-terminal stage.',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MoveToStage.aiTerminalStageValidationError`,
  },
});
